/* global store */
import { getElementFromEvent } from 'Render/utils/index';
import {
  INTERVAL_TILL_HOVER,
  IN_VIEW_WAIT_TIME,
} from 'Tracking/constants/index';
import {
  AD_DWELL_TIME,
  AD_COMPONENT_ID,
  AD_COMPONENT_NAME,
  AD_STATE,
} from 'Tracking/constants/trackingNames';
import {
  MOUSEOVER,
  HOVER,
  DWELL,
  VIEW,
  TIME_IN_VIEW,
} from 'Tracking/constants/events';

import {
  getDwell,
} from 'Render/tracking/selectors/index';
import { fireTracking } from 'Tracking/index';
import { getClosest } from 'Tracking/utils';

const getCarouselComponentInfo = (elem) => {
  const componentId = elem ? elem.getAttribute('data-id') || null : null;
  const componentName = elem ? elem.getAttribute('data-name') || null : null;
  const componentContainer = elem ? getClosest(elem, 'div[data-artboard]') || null : null;
  const componentArtboard = componentContainer ? componentContainer.getAttribute('data-artboard') || null : null;
  return {
    [AD_COMPONENT_ID]: componentId,
    [AD_COMPONENT_NAME]: componentName,
    [AD_STATE]: componentArtboard,
  };
};

const maybeFireHover = () => setTimeout(() => {
  fireTracking(HOVER);
}, INTERVAL_TILL_HOVER);

export const mouseEnterAdTracking = () => {
  const { hasEntered = false } = store.getState();

  if (hasEntered) return;

  fireTracking(MOUSEOVER);

  const hoverTimeout = maybeFireHover();

  store.dispatch({
    type: 'UPDATE_HOVER_HELPERS',
    hoverTimeout,
    hasEntered: true,
    hoverStartTime: new Date(),
  });
};

export const mouseLeaveAdTracking = (e) => {
  const {
    rootElement,
    hoverTimeout,
    hoverStartTime,
    hasEntered,
  } = store.getState();

  const element = getElementFromEvent(e);

  if (!hasEntered || element.id !== rootElement.id) return;

  clearTimeout(hoverTimeout);
  fireTracking(DWELL, { [AD_DWELL_TIME]: getDwell(hoverStartTime) });

  store.dispatch({
    type: 'UPDATE_HOVER_HELPERS',
    hasEntered: false,
    hoverStartTime: new Date(),
  });
};

const maybeFireView = () => (
  setTimeout(() => fireTracking(VIEW), IN_VIEW_WAIT_TIME));

export const adMovedIntoView = () => {
  store.dispatch({
    type: 'AD_MOVED_INTO_VIEW',
    viewTimeoutId: maybeFireView(),
    inViewStartTime: new Date(),
  });
};

export const adMovedOutOfView = () => {
  const { viewTimeoutId, inViewStartTime } = store.getState();
  global.clearTimeout(viewTimeoutId);
  fireTracking(TIME_IN_VIEW, { [AD_DWELL_TIME]: getDwell(inViewStartTime) });
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/actions/ad.js